<template>
  <div class="block-r">
    <div class="block-r__row">
      <div class="block-r__image" data-aos="fade-up">
        <img src="../assets/img/block-r-1.jpg" alt="">
      </div>
      <div class="block-r__letter letter letter-white" data-aos="fade-up">
        Р.
      </div>
    </div>
    <div class="block-r__title" data-aos="fade-up">Ревущие <span>20</span>-ые</div>
    <div class="block-r__text text-white" data-aos="fade-up">Конец Первой мировой войны ознаменовал начало новой эпохи — эпохи расцвета джаза, арт-деко, повсеместного радиовещания и появления звука в кинематографе. Благодаря беспрецедентному росту промышленности и потребительского спроса, научным открытиям и технологическому прогрессу дух ревущих двадцатых воспринимался современниками, как время разрыва <br>с традиционными ценностями, время фривольного дикого танца, время, когда осуществимо всё.</div>
  </div>
</template>

<script>
export default {
  name: 'BlockV'
}
</script>

<style lang="sass">
  .block-r
    &__image
      width: vw(955px)
      position: relative
      img
        width: 100%
      &:after
        content: ''
        display: block
        width: vw(78px)
        height: vw(78px)
        border: 1px solid #fff
        position: absolute
        border-top: none
        border-right: none
        bottom: vw(-16px)
        left: vw(-20px)
    &__row
      display: flex
      padding-left: vw(215px)
    &__letter
      color: #000
      margin-left: vw(-140px)
      margin-top: vw(117px)
      padding-left: vw(25px)
      padding-top: vw(15px)
    &__title
      font-size: vw(72px)
      color: #fff
      font-family: 'ZnikomitNo25'
      text-align: center
      margin-top: vw(-141px)
      margin-left: vw(12px)
      position: relative
      z-index: 10
      span
        font-size: vw(200px)
        color: #E1C99C
    &__text
      width: vw(800px)
      margin: auto
      text-align: center
      font-family: 'Tautz'
      font-size: vw(16px)
      margin-top: vw(24px)
      padding-left: vw(13px)
      line-height: vw(20px)
</style>
